export const shouldShowShareButton = (sharedSubmission) => {
    return sharedSubmission?.sharedWith !== "ANYONE_WITH_LINK";
  };
  
  export const shouldShowUnshareButton = (sharedSubmission) => {
    return sharedSubmission?.sharedWith === "ANYONE_WITH_LINK";
  };